/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModeCalculTarification } from './ModeCalculTarification';
import {
    ModeCalculTarificationFromJSON,
    ModeCalculTarificationFromJSONTyped,
    ModeCalculTarificationToJSON,
    ModeCalculTarificationToJSONTyped,
} from './ModeCalculTarification';

/**
 * Tarification transmise en écriture.
 * @export
 * @interface TarifCommandDto
 */
export interface TarifCommandDto {
    /**
     * 
     * @type {ModeCalculTarification}
     * @memberof TarifCommandDto
     */
    modeCalcul: ModeCalculTarification;
    /**
     * 
     * @type {number}
     * @memberof TarifCommandDto
     */
    montantFixe?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TarifCommandDto
     */
    montantFixeHT?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TarifCommandDto
     */
    taux?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TarifCommandDto
     */
    expression?: string | null;
}



/**
 * Check if a given object implements the TarifCommandDto interface.
 */
export function instanceOfTarifCommandDto(value: object): value is TarifCommandDto {
    if (!('modeCalcul' in value) || value['modeCalcul'] === undefined) return false;
    return true;
}

export function TarifCommandDtoFromJSON(json: any): TarifCommandDto {
    return TarifCommandDtoFromJSONTyped(json, false);
}

export function TarifCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TarifCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'modeCalcul': ModeCalculTarificationFromJSON(json['modeCalcul']),
        'montantFixe': json['montantFixe'] == null ? undefined : json['montantFixe'],
        'montantFixeHT': json['montantFixeHT'] == null ? undefined : json['montantFixeHT'],
        'taux': json['taux'] == null ? undefined : json['taux'],
        'expression': json['expression'] == null ? undefined : json['expression'],
    };
}

export function TarifCommandDtoToJSON(json: any): TarifCommandDto {
    return TarifCommandDtoToJSONTyped(json, false);
}

export function TarifCommandDtoToJSONTyped(value?: TarifCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modeCalcul': ModeCalculTarificationToJSON(value['modeCalcul']),
        'montantFixe': value['montantFixe'],
        'montantFixeHT': value['montantFixeHT'],
        'taux': value['taux'],
        'expression': value['expression'],
    };
}

